import dayjs from 'dayjs'
import { format as formatDateFns } from 'date-fns'

export const formatDate = (date, format = 'YYYY-MM-DD HH:mm:ss', defaultString: string = '') => {
  try {
    const d = new Date(date)
    return d ? dayjs(d).format(format) : defaultString
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('parse Date error，source date is ', date)
  }
  return dayjs
}

// date-fns中format函数封装，兼容传入的date为空的情况
export const format = (date, template) => {
  if (!date) return '-'
  return formatDateFns(date, template)
}
